import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/quality-check/extra-reducer';
import reducers from 'src/redux/quality-check/reducers';
import type { QualityCheckTypeInitStateType } from 'src/redux/quality-check/types';

const initialState: QualityCheckTypeInitStateType = {
  isQualityCheckFetching: false,
  isTripCostBreakdownUpdating: false,
  isQCIssueExpandedDataFetching: false,
  isAddingOrEditingMaterial: false,
  isUploadingBeforeMedia: false,
  isUploadingAfterMedia: false,
  isQualityCheckSubmitting: false,
  isQualityCheckSaving: false,
  expandedIssueId: '',
  workOrderId: null,
  workOrderIssueIds: [],
  workOrderIssueSource: {},
  tripCostBreakdown: {
    tripIds: [],
    tripCostSource: {},
    totalCost: 0,
  },
  tripNumber: 0,
  expandedIssueSource: {},
};

const qualityCheck = createSlice({
  name: 'qualityCheck',
  initialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  updateExpandedIssueId,
  updateTripStatus,
  updateIsUploadingMedia,
  updateQualityCheckIssueStatus,
  updateQCMaterialOnPusher,
  deleteQcMaterialOnPusher,
} = qualityCheck.actions;

export default qualityCheck.reducer;
